import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FboFinderFilter } from '../models/fbo-finder-filter.model';

/**
 * Shares the Business Finder (FBO) filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FlightSchoolFinderFiltersService} (a root-provided BehaviorSubject).
 */
@Injectable({
  providedIn: 'root'
})
export class FboFinderFiltersService {

  private fboFinderFilterSubject$ = new BehaviorSubject<FboFinderFilter>(new FboFinderFilter());
  fboFinderFilter = this.fboFinderFilterSubject$.asObservable();

  constructor() { }

  updateFboFinderFilters(fboFinderFilter: FboFinderFilter) {
    this.fboFinderFilterSubject$.next(fboFinderFilter);
  }
}
